<div class="empty-table">
	<app-image
		imageSrc="images/icons/empty-folder.svg"
		imageWidth="140px"
		imageAlt="empty"
	/>
	<span class="title">{{ textPath | translate }}</span>
</div>
